import React from "react";

interface LetterCardProps {
  letter: string | React.ReactNode;
  color?: string;
  backgroundColor?: string;
  className?: string;
  letterClassName?: string;
}

export default function LetterCard({
  letter,
  color,
  backgroundColor,
  className,
  letterClassName,
}: LetterCardProps) {
  return (
    <button
      style={{ backgroundColor: backgroundColor }}
      className={`flex size-[24px] min-w-[30px] min-h-[30px] items-center justify-center rounded-[2px] ${className}`}
    >
      <span
        style={{ color: color }}
        className={`leading-[18px] font-medium ${letterClassName}`}
      >
        {letter}
      </span>
    </button>
  );
}
